exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tasks-result .caption-currentTask {\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #aaaaaa;\n  padding-bottom: 0;\n  letter-spacing: 1px; }\n\n.tasks-result .buttons {\n  margin: 24px 0 48px; }\n\n.tasks-result .result-bottom .bttn {\n  background-color: #aaa;\n  border-color: #aaa;\n  color: #fafafa;\n  margin-bottom: 24px; }\n  .tasks-result .result-bottom .bttn:hover, .tasks-result .result-bottom .bttn:focus {\n    background-color: #1356A8;\n    border-color: #1356A8; }\n", ""]);

// exports
